import React, { Component } from "react";
import { Icon, Select, message, Popover, DatePicker, Input, Button, Form, Table } from "antd";

import { auth } from '../firebase';
import "../App.css";
import { db, storr } from '../firebase/firebase';


export class Promotions extends Component {
  constructor(props) {
    super(props);

    // Set the default state of our application
    this.state = {
      pendingMedia: "",
      data: [],
      pendingData: { startdate: "2018-01-01", enddate: "2019-02-02", title: "", location: "", image: "", inputDisabled: false, disabled: true },
      columns: [],
      tempStatus: '',
      locationList: [],
      filterList: [],
      ta: null,
      pa: null,
      aa: null,
      show: false,
      html: "<p>write some text here</p>",
      editorState: null,
    };
    this.getLocationList()

    this.deleteProject = this.deleteProject.bind(this);

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      }
    });
  }


  selector(key, value) {
    // this.state.data[key].isSold = value;
    this.setState({ tempStatus: value });
  }

  async getLocationList() {
    await db.collection("location").onSnapshot(snapshot => {
      let locationList = [];
      let filterList = [];
      snapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        const todo = doc.data()
        todo.id = doc.id
        locationList.push(todo)

        var obj = { text: todo.name, value: todo.id }
        filterList.push(obj)
      })
      // Anytime the state of our database changes, we update state
      this.setState({ locationList, filterList })
      this.setColumes()
      this.pullFromDB()
    })
  }

  setColumes = () => {
    var columns = [
      {
        title: 'Start Date',
        dataIndex: 'startdate',
        width: '11%',
        ...this.getColumnSearchProps('startdate'),
        editable: true,
        sorter: (a, b) => { return a.startdate.localeCompare(b.startdate) },
        render: (text, record) => {
          return (
            <div>
              {text}
            </div>
          );
        },
      },
      {
        title: 'End Date',
        dataIndex: 'enddate',
        width: '11%',
        ...this.getColumnSearchProps('enddate'),
        sorter: (a, b) => { return a.enddate.localeCompare(b.enddate) },
        inputType: 'areaa',
        editable: true,
      },
      {
        title: 'Title',
        dataIndex: 'title',
        ...this.getColumnSearchProps('title'),
        sorter: (a, b) => { return a.title.localeCompare(b.title) },
        editable: true,
      },
      {
        title: 'Location',
        dataIndex: 'location',
        sorter: (a, b) => { return a.location.localeCompare(b.location) },
        filters: this.state.filterList,
        onFilter: (value, record) => record.location.indexOf(value) === 0,
        render: (text, record) => {
          return (
            <div>
              {this.idToName(this.state.data[record.key].location)}
            </div>
          );
        },
      },
      {
        title: 'Image',
        dataIndex: 'image',
        editable: false,
        render: (text, record) => {
          return (
            <div>
              <a href={record.image} target="_blank"><img src={record.image} alt={record.image} height="100">
              </img></a>
            </div>
          )
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          return (
            <div>
              <Button
                type='primary'
                onClick={() => this.archive(record.key)}
                style={{ marginRight: 8 }}
              >
                Restore
                </Button>
              <Button
                type='danger'
                onClick={() => this.deleteProject(record.key)}
              >
                <Icon type="delete" />
                            </Button>
            </div>
          );
        },
      },
    ];
    this.setState({ columns })
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }


  archive = (ppd) => {
    var idpath = this.state.data[ppd].id

    db.collection("promotions").doc(idpath).update({
      archived: false
    })
      .then(function () {
        message.success("Document " + idpath + " successfully restore!");
      })
      .catch(function (error) {
        // The document probably doesn't exist.
        message.error(error.message)
      });
  }

  async deleteProject(ppd) {
    var idpath = this.state.data[ppd].id
    var imgpath = this.state.data[ppd].id + this.state.data[ppd].ext

    await db
      .collection("promotions")
      .doc(this.state.data[ppd].id)
      .delete().then(function () {
        message.success("Row " + idpath + " deleted successfully")
        var ref = storr.ref(imgpath);

        ref.getMetadata().then(function (metadata) {
          ref.delete().then(function () {
            message.success("File " + imgpath + " deleted successfully")
          }).catch(function (error) {
            message.error("Uh-oh, an error occurred! " + error.message)
          });
        }).catch(function (error) {
          // message.error("Uh-oh, an error occurred! " + error.message)
        });

      }).catch(function (error) {
        message.error(error.message)
      });
  }


 



  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("promotions").where('archived', '==', true).onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      //sort by timestamp
      data.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : 1)

      //assign primary key for edit function to work properly
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }

      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })

  }

  idToName(k) {
    var idtn = 'location'
    this.state.locationList.forEach((obj, i) => {
      if (k.trim() === obj.id.trim())
        idtn = obj.name
    });
    return idtn
  }



  render() {
    // console.log(this.state.email)
    // const { editorState } = this.state;
    const components = {
      body: {
      },
    };

    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'title' ? 'areaa' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
        }),
      };
    });
    return (
      <div>
        <h1 className="block">Archived Promotions</h1>

        {this.state.email == 'cc@cc.cc' ?
          <div> debug</div>
          :
          <div />
        }

        <Table
          components={components}
          bordered
          pagination={{ pageSize: 15 }}
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />
      </div>

    )
  }

}
export default Promotions;



// WEBPACK FOOTER //
// ./src/views/apromotions.js